import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { SignInForm } from './SignInForm';
import { SignUpForm } from './SignUpForm';
import { ResetPasswordForm } from './ResetPasswordForm';

import * as AUTH_SELECTORS from '../../store/selectors/auth';

import { SIGN_IN_STEP } from '../../const/auth/SIGN_IN_STEP';
import { SIGN_UP_STEP } from '../../const/auth/SIGN_UP_STEP';
import { RESET_PASSWORD_STEP } from '../../const/auth/RESET_PASSWORD_STEP';

const SIGN_IN_STEPS = [
    SIGN_IN_STEP.LOGIN,
    SIGN_IN_STEP.VERIFY_PASSWORD,
];

const SIGN_UP_STEPS = [
    SIGN_UP_STEP.VERIFY_EMAIL,
    SIGN_UP_STEP.FILL_PROFILE,
];

const RESET_PASSWORD_STEPS = [
    RESET_PASSWORD_STEP.VERIFY_CODE,
    RESET_PASSWORD_STEP.SET_PASSWORD,
];

const AuthForm = (props) => {
    const { showFooter } = props;

    const { step } = useSelector(AUTH_SELECTORS.authSelector);

    if (SIGN_IN_STEPS.includes(step)) {
        return (
            <SignInForm showFooter={showFooter} />
        );
    }

    if (SIGN_UP_STEPS.includes(step)) {
        return (
            <SignUpForm showFooter={showFooter} />
        );
    }

    if (RESET_PASSWORD_STEPS.includes(step)) {
        return (
            <ResetPasswordForm showFooter={showFooter} />
        );
    }

    return (
        <SignInForm showFooter={showFooter} />
    );
};

const Footer = () => {
    const { step } = useSelector(AUTH_SELECTORS.authSelector);

    if (SIGN_IN_STEPS.includes(step)) {
        return (
            <SignInForm.Footer />
        );
    }

    if (SIGN_UP_STEPS.includes(step)) {
        return (
            <SignUpForm.Footer />
        );
    }

    if (RESET_PASSWORD_STEPS.includes(step)) {
        return (
            <ResetPasswordForm.Footer />
        );
    }

    return (
        <SignInForm.Footer />
    );
};

AuthForm.Footer = Footer;

AuthForm.propTypes = {
    showFooter: PropTypes.bool,
};

AuthForm.defaultProps = {
    showFooter: true,
};

export default AuthForm;
